import { Component, OnInit } from '@angular/core';
import { AspWarrantyCertificateListService } from './asp-warranty-certificate-list.service';
import { Router } from '@angular/router';
import { AspLoadingService } from '../asp-loading/asp-loading.service';

@Component({
  selector: 'app-asp-warranty-certificate-list',
  templateUrl: './asp-warranty-certificate-list.component.html',
  styleUrls: ['./asp-warranty-certificate-list.component.scss']
})
export class AspWarrantyCertificateListComponent implements OnInit {

  registeredParts: any[] = [];
  allParts: any[] = [];
  loading: boolean = false;
  searchText: string = "";
  hideScrollText: boolean = false;
  isMobile: boolean = false;

  constructor(
    private warrantyService: AspWarrantyCertificateListService,
    private router: Router,
    private aspLoadingService: AspLoadingService,
  ) {}

  ngOnInit(): void {
    this.loadRegisteredParts();
  }

  loadRegisteredParts() {
    this.aspLoadingService.show();
    const garageKey = localStorage.getItem("garageKey");

    if (!garageKey) {
      // console.error("Garage Key is missing in localStorage!");
      return;
    }

    this.warrantyService.getRegisteredPartList(garageKey).subscribe(
      (res: any) => {
        this.aspLoadingService.hide();
        // console.log("Registered Parts API Response:", res);

        if (res?.data) {
          // Save original data in allParts and set displayed list to full list
          this.allParts = Array.isArray(res.data) ? res.data : [];
          this.registeredParts = [...this.allParts];
        } else {
          this.allParts = [];
          this.registeredParts = [];
        }
      },
      (err) => {
        // console.error("Registered Parts API Error:", err);
      }
    );
  }

  goToDetails(item: any) {
    if (!item?.orderKey) {
      // console.error("Invalid orderKey", item);
      return;
    }
    this.router.navigate(['/warranty-list-details',  item.orderKey, item.packageId]);
  }

  // 🔍 SEARCH FILTER FUNCTION
  filterCertificates() {
    const value = (this.searchText || "").trim().toLowerCase();
    // console.log("searchText", value)

    // toggle placeholder / clear button visibility
    this.hideScrollText = value.length > 0;

    // If search empty — reset displayed list
    if (!value) {
      this.registeredParts = [...this.allParts];
      return;
    }

    // Filter from the full backup (allParts)
    this.registeredParts = this.allParts.filter(item => {
      const regNo = (item.registrationNumber || "").toString().toLowerCase();
      const name = (item.userName || "").toString().toLowerCase();
      const mobile = (item.userMobile || "").toString().toLowerCase();
      // const orderKey = (item.orderKey || "").toString().toLowerCase();
      // const packageId = (item.packageId || "").toString().toLowerCase();
      const id = (item.id || "").toString().toLowerCase();
      const certificateNumber = (item.certificateNumber || "").toString().toLowerCase();

      return (
        regNo.includes(value) ||
        name.includes(value) ||
        mobile.includes(value) ||
        // orderKey.includes(value) ||
        // packageId.includes(value) ||
         id.includes(value) ||
         certificateNumber.includes(value)
      );
    });
  }

  clearSearch() {
    this.searchText = '';
    this.hideScrollText = false;
    this.registeredParts = [...this.allParts];
  }
}
